import SearchIcon from '@/assets/svg/search.svg?react';
import EmptyList from '@/components/common/EmptyList';
import LoadingComponent from '@/components/common/Loading';
import { useGetLearningList } from '@/services/learning';
import {
  Box,
  Input,
  SimpleGrid,
  Card,
  Text,
  InputGroup,
  InputLeftElement,
  VStack,
} from '@chakra-ui/react';
import React, { useState } from 'react';

export default function VideoGrid() {
  const [search, setSearch] = useState('');

  const { data, isLoading } = useGetLearningList(search);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };
  const getEmbedUrl = (url: string) => {
    try {
      const urlObj = new URL(url);
      if (urlObj.hostname === 'www.youtube.com' || urlObj.hostname === 'youtube.com') {
        const videoId = urlObj.searchParams.get('v');
        if (videoId) {
          return `https://www.youtube.com/embed/${videoId}`;
        }
      }
      // Return null or a fallback URL if the input is invalid
      return null;
    } catch {
      return null;
    }
  };
  return (
    <Box p={4} fontFamily={'primary'}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
        <Text fontWeight={'semibold'}>Videos</Text>
        <InputGroup maxW="350px">
          <InputLeftElement pointerEvents="none">
            <SearchIcon />
          </InputLeftElement>
          <Input
            placeholder="Search"
            borderRadius="md"
            border="1px solid"
            borderColor={'border.default'}
            onChange={handleInputChange}
          />
        </InputGroup>
      </Box>

      {isLoading ? (
        <LoadingComponent />
      ) : data?.results.length === 0 ? (
        <EmptyList />
      ) : (
        <SimpleGrid columns={{ base: 1, md: 2, lg: 5 }} spacing={4} mt={4}>
          {data?.results.map(
            (
              video: {
                url: string;
                title: string;
                author: string;
              },
              index: number,
            ) => {
              const embedUrl = getEmbedUrl(video.url);
              return (
                <Card key={index} borderRadius="md" boxShadow="md">
                  <Box borderTopLeftRadius={'md'} borderTopRightRadius={'md'} overflow="hidden">
                    {embedUrl ? (
                      <iframe
                        width="100%"
                        height="200"
                        src={embedUrl}
                        title={video.title}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    ) : (
                      <Box
                        width="100%"
                        height="200"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        bg="gray.100"
                      >
                        <Text color="text.secondary">Invalid or non-embeddable video URL</Text>
                      </Box>
                    )}
                  </Box>
                  <VStack align="start" mt={4} gap={1} p={2}>
                    <Text fontWeight="semibold">{video.title}</Text>
                    <Text fontSize="sm" color={'text.secondary'}>
                      {video.author}
                    </Text>
                  </VStack>
                </Card>
              );
            },
          )}
        </SimpleGrid>
      )}
    </Box>
  );
}
